import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import EtapaConfiguracaoService from "../../services/resource/etapaConfiguracaoService";

const service = new EtapaConfiguracaoService();

export function useEtapasConfiguracao() {
    const [etapas, setEtapas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [salvandoChave, setSalvandoChave] = useState(null);

    const carregar = useCallback(() => {
        setLoading(true);
        service.listarTodas()
            .then(res => setEtapas(res.data))
            .catch(error => {
                console.error("Erro ao listar configuração de etapas", error);
                toast.error("Erro ao carregar configuração de etapas");
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        carregar();
    }, [carregar]);

    function alternarAnexoObrigatorio(etapa) {
        const chave = `${etapa.tipoProcesso}:${etapa.etapaCodigo}`;
        setSalvandoChave(chave);
        service.salvar(etapa.tipoProcesso, {
            etapaCodigo: etapa.etapaCodigo,
            anexoObrigatorio: !etapa.anexoObrigatorio,
            prazoHoras: etapa.prazoHoras,
        })
            .then(() => {
                toast.success("Configuração da etapa atualizada!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao salvar configuração da etapa", error);
                toast.error("Erro ao salvar configuração da etapa");
            })
            .finally(() => setSalvandoChave(null));
    }

    // `prazoHoras` nulo = sem prazo configurado (a etapa deixa de ser considerada atrasada).
    function salvarPrazoHoras(etapa, prazoHoras) {
        const chave = `${etapa.tipoProcesso}:${etapa.etapaCodigo}`;
        setSalvandoChave(chave);
        service.salvar(etapa.tipoProcesso, {
            etapaCodigo: etapa.etapaCodigo,
            anexoObrigatorio: etapa.anexoObrigatorio,
            prazoHoras,
        })
            .then(() => {
                toast.success("Prazo da etapa atualizado!");
                carregar();
            })
            .catch(error => {
                console.error("Erro ao salvar prazo da etapa", error);
                toast.error("Erro ao salvar prazo da etapa");
            })
            .finally(() => setSalvandoChave(null));
    }

    return { etapas, loading, salvandoChave, alternarAnexoObrigatorio, salvarPrazoHoras };
}
